
import { defineComponent } from 'vue';

import Form from '@/shared/mixins/Form';
import { adFilterService } from '@/ad/AdFilterService';
import { required } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import { mapState } from 'vuex';
import { GlobalState } from '@/shared/models/GlobalState';
import { googleTagManagerService } from '@/shared/services/GoogleTagManagerService';

export default defineComponent({
  name: 'AdFilter',
  mixins: [Form],
  emits: ['close'],
  setup() {
    return { v$: useVuelidate() };
  },
  props: {
    adFilterId: String,
    title: String,
    params: Object,
    frequencies: Array,
  },
  data() {
    return {
      createNew: false,
      form: {
        adFilterId: '',
        title: '',
        frequency: 1,
        filter: '',
      },
    };
  },
  validations() {
    return {
      form: {
        title: { required },
        frequency: { required },
      },
    };
  },
  computed: {
    ...mapState({
      user: (state) => (state as GlobalState).user,
    }),
    isEdit() {
      return !!this.adFilterId;
    },
  },
  created() {
    if (this.title) {
      this.form.title = this.title;
    }
  },
  methods: {
    async save() {
      if (!this.validate()) return;

      try {
        this.form.filter = JSON.stringify(this.params);
        if (!this.createNew && this.adFilterId) {
          this.form.adFilterId = this.adFilterId;
          await adFilterService.update(this.form);
        } else {
          var result = await adFilterService.insert(this.form);
          this.form.adFilterId = result.data.adFilterId;
        }
        this.success();

        googleTagManagerService.send({
          event: 'hladanie_ulozene',
        });
      } catch (error) {
        this.handleApiError(error);
      }
      if (this.isSuccess && this.$route.query && this.$route.query.adFilterId) {
        const query = { ...this.$route.query, adFilterId: this.form.adFilterId } as any;
        const { href } = this.$router.resolve({ path: this.$route.path, query });
        window.history.pushState({}, '', href);
      }
    },
    close() {
      this.$emit('close');
    },
  },
});
